import { AxiosResponse } from 'axios';
import api from '../../../services/api';

class LoadTypeService {
  getAll() {
    return api.get('/load/type/');
  }
  getLoadType(id: any) {
    return api.get(`/load/type/${id}`);
  }
  deleteLoadType(id: any) {
    return api.delete(`/load/type/${id}`);
  }
  createLoadType(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/load/type/', payload);
  }
  editLoadType(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put('/load/type/', payload);
  }
}

export default new LoadTypeService();
